import { useGetMyHomepageQuery } from '../generated/graphql';

interface UseGetHomepageOptions {
  skip?: boolean;
}

/**
 * Hook to fetch the user's preferred homepage setting
 * @param options.skip - Skip the query if true (useful when tenantId is not yet set)
 */
export const useGetHomepage = (options?: UseGetHomepageOptions) => {
  const { data, loading, error, refetch } = useGetMyHomepageQuery({
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    skip: options?.skip,
  });

  return {
    homepage: data?.getMyHomepage?.homepage,
    loading,
    error,
    refetch,
  };
};
